import React, {useEffect, useState} from 'react'
import "./Comms.scss"
import Intro from "./Intro/Intro";
import Link from "./Link/index.js";
import Header from '../../partials/Header';
import Modal from "../../partials/Modal/SimpleModal/SimpleModal";
import Splash from "./common/Splash"
// import Simulation from "./Simulation";
import Simulation from "../Payload/Simulation";
import InteractionContainer from '../../partials/InteractionContainer/InteractionContainer';

function CommsLink({ data, breadcrumbs, onComplete }) {

    const [currentView, setCurrentView] = useState()
    const [showModal, setShowModal] = useState(false);
    const [buttonsState, setButtonState] = useState(()=>[
        { 
            text: data.requirements.button, 
            action: (e)=> handleModal(e, {
                title: data.requirements.button,
                body: data.requirements.content
            }),
            disabled: false
        },
        { 
            text: data.formulas.button, 
            action: (e)=> handleModal(e, {
                title: data.formulas.button,
                body: data.formulas.content

            }),
            className: 'formulas',
            disabled: true,
            hide: true
        }
    ])

    const [linkResponses, setLinkResponses] = useState();


    useEffect(() => {

        if(!currentView) showLinkView()

    }, []) 

    const enableButton = (name, enable, hide) => {
        return buttonsState.map((button)=> {
            if(button.text === name) return { ...button, disabled: !enable, hide: hide }
            return button
        })
    }

   
    const handleCompletedLink = (answers) =>{
        setLinkResponses([...answers])
        setCurrentView({
            name: 'simulation',
            data: data.link.outcomes
        })

    }

    
    const showLinkView = () => {
        setButtonState(enableButton('Formulas', true))
        setCurrentView({
            name: 'link', 
            header: { 
                title: data.link.title, 
                intro: data.link.description 
            },
            content: data.link
        })
    }

    /**
     * handleModal
     * opens a shared modal component
     * @param {*} e 
     * @param {*} obj 
     */
    const handleModal = (e, obj) => {
        
        setShowModal({
            title: obj.title,
            body:obj.body
        });


    }
    /**
     * handleModalClose
     * close a shared modal component
     * @param {*} e 
     * @param {*} obj 
     */

    const handleModalClose = (e) =>{
        setShowModal(false);
    }

    return <InteractionContainer withFrame={true} breadcrumbs={breadcrumbs}>

        {/* Intro Screen */}
        {currentView && currentView.name =='intro' &&
            <Intro 
                show={true} 
                content={currentView.content}
                onClose={ showLinkView } />
        }
        {/* Simulation Screen */}
        {currentView && currentView.name =='simulation' &&
            <Simulation data={currentView.data} 
                outcomes={currentView.data} 
                onBack={showLinkView}
                onComplete={onComplete}
                    />
        }
        {/* Shared Header */}
        {currentView && currentView.header &&
            <Header 
                title={currentView.header.title} 
                intro={currentView.header.intro} 
                buttonset={buttonsState}
            />
        }
        
        {/* Main Content */}
        <main className={'comms-content'} >

            {/* Splash content */}
            {currentView && currentView.name === 'splash' && 
                <Splash 
                    content={currentView.content} 
                    buttons={currentView.buttons}    
                />
            }
            
            {/* Link content */}
            {currentView && currentView.name === 'link' && 
                <Link data={currentView.content} onComplete={handleCompletedLink} />
            }

            
        </main>

        {/* Shared Modal */}
        <Modal
            size='small'
            show={showModal ? true : false}
            header={showModal ? showModal.title : false}
            html={showModal ? showModal.body : false}
            onClose={handleModalClose} >
                
                {/* Conditional Childrens */}

                
                {showModal && showModal.title==="Comms Decisions" && linkResponses &&
                    <>
                        {linkResponses.map((response, index) => (
                            <div key={index}>{ response.name }: {response.value}</div>
                        ))}
                    </>
                }

            
        </Modal>
    </InteractionContainer>
}

export default CommsLink;
